import React, { Component } from 'react'
import { Link, Redirect } from "react-router-dom"
import { connect } from "react-redux"
import { Field, reduxForm } from 'redux-form'
import agent from '../agent'

import { store, history } from '../store/configureStore'
import { push } from 'react-router-redux';

import Modal from 'react-responsive-modal';

import Back from "../components/Back";
import Svg from '../components/Svg';
import Aux from './AuxContainer'
import AMLogo from '../assets/images/audition-magic-favicon.png';

import FindMe from '../components/FindMe'
import ArtistLoginForm from '../components/ArtistLoginForm'
import ImDb from '../components/ImDb';

import Background from '../assets/images/stock1.jpg'


const Header = (props) => {
	console.log('Header', props)
	if (props && props.projectId) {
		let companyLogo = ''
		
		if (props.token) {
			companyLogo = props.client.logo_url
		} else if (props.client.default_company_details) {
			companyLogo = props.client.default_company_details.logo_url
		} else  {
			companyLogo = props.client.logo_url
		}

		return (
			<section id="brand-logo" className="section-brand-logo section">
			 
			  <div className="row text-center">
				  <div className="small-12 medium-4 medium-offset-4 column">
				  	<div className="header-image-container">
					  	<img className="company-logo" src={companyLogo} alt="" />
				  	</div>
				  </div>
				  <div className="small-12 medium-4 column">
				  	<div className="header-image-container">
							<img className="project-logo" src={props.projectId.cover_url} alt="" />
						</div>
				  </div>
				</div>

			  <div className="row">
				  <div className="small-12 small-centered column text-center with-name">
				    <p className="project-name">{props.projectId.name}</p>
				    <p className="top-title">Please login or select the <b>Create New Account</b> button if you are new</p>
				  </div>
			  </div>
			</section>
		)
	}
	return (
		<section id="brand-logo" className="section-brand-logo section">
		  <div className="row">
		  <div className="small-12 small-centered column text-center">
		  	<div className="header-image-container">
			  	<img className="am-logo" src={AMLogo} alt="" />
		  	</div>
		    <p className="top-title">Audition Magic Check-in</p>
		  </div>
		  </div>
		</section>
	)
}

class ArtistLoginContainer extends Component {
	state = { 
		redirect: false, 
		showModal: false,
		isCheckingArtist: false,
		errorMessage: null,
		projectId: null,
		token: '',
		headerParams: {},
    client: {},
    loading: true
	}


	getInitialValues () {
		const username = this.props.location.state && this.props.location.state.thisIsMeArtist ? this.props.location.state.thisIsMeArtist.email : ""
		return {
			username: username
		}
	}

	async componentDidMount() {
  	const { match, location, artistToken } = this.props
  	let projectId = new URLSearchParams(location.search).get('project');
  	const token = new URLSearchParams(location.search).get('token');
  	const imdb = new URLSearchParams(this.props.location.search).get('imdb')
  	
    let project1 = null
    if (projectId) {
      project1 = await agent.Project.projectById(projectId)
    } else if (token) {
      project1 = await agent.Project.viaToken(token)
    }
  	
  	let myInfo = null
    try {
      myInfo = await agent.Agency.companyDetails(project1.project.company_id)
    } catch (err) {

    }

    if (projectId == null && project1 != null) 
      projectId = project1.project.id
  	
    const client = (myInfo == null) ? location.state.client : myInfo.company
		this.setState({ headerParams: { projectId, client }, client: client })



  	if (project1) {
  		this.setState({
  			projectId: project1.project
  		})
  	}
  	if (artistToken && token) {
  		
  		let publicArtist = {
  			agencies: this.props.artistInfo.agencies,
  			aritst: this.props.artistInfo,
  			auditions: this.props.artistInfo.auditions || [],
  			meta: artistToken
  		}

  		if (imdb) {
	  		this.props.history.push({
				  pathname: '/artist/dashboard',
				  search: `?token=${token}&imdb=${imdb}`,
				  state: { 
				  	artist: this.props.artistInfo, 
				  	publicArtist: publicArtist,
				  	clientDetails: {
				  		projectId: project1.project,
				  		client: client
				  	}
				  }
				})
		} else {
			this.props.history.push({
				  pathname: '/artist/dashboard',
				  search: `?token=${token}`,
				  state: { 
				  	artist: this.props.artistInfo, 
				  	publicArtist: publicArtist,
				  	clientDetails: {
				  		projectId: project1.project,
				  		client: client
				  	}
				  }
				})
		}

  	} else if (artistToken && !projectId) {
  		history.push('/artist/dashboard')
  	}

    this.setState({loading: false});
	}

  componentWillReceiveProps(nextProps) {
  	const { location } = this.props
  	const paramId = new URLSearchParams(location.search).get('project')
  	
  	if(nextProps.partialArtist) {
  		agent.setToken(nextProps.partialArtist.client)
  		this.checkArtist(paramId, nextProps.partialArtist, 'login')
  	} else if (nextProps.publicArtist && !nextProps.publicArtist.message) {
      window.localStorage.setItem('artist_jwt', JSON.stringify(nextProps.publicArtist));
      window.localStorage.setItem('user_jwt', JSON.stringify(nextProps.publicArtist.meta));
  		agent.setToken(nextProps.publicArtist.meta)
  		this.publicCheckArtist(nextProps.publicArtist)
  	}
  }

  componentWillUnmount() {
  	this.props.onUnload();
  }


  publicCheckArtist = (publicArtist) => {
  	const { location } = this.props
  	const token = new URLSearchParams(location.search).get('token')
  	const imdb = new URLSearchParams(this.props.location.search).get('imdb')
  	
  	if (imdb) {
	  	this.props.history.push({
			  pathname: '/artist/dashboard',
			  search: `?token=${token}&imdb=${imdb}`,
			  state: { 
			  	artist: publicArtist.artist, 
			  	publicArtist: publicArtist,
			  	clientDetails: {
			  		projectId: this.state.projectId,
			  		client: this.state.client
			  	}
			  }
			})
	} else {
		this.props.history.push({
			  pathname: '/artist/dashboard',
			  search: `?token=${token}`,
			  state: { 
			  	artist: publicArtist.artist, 
			  	publicArtist: publicArtist,
			  	clientDetails: {
			  		projectId: this.state.projectId,
            client: this.state.client
			  	}
			  }
			})
	}
  }

  checkArtist = (projectId, artist, from) => {
		const { location } = this.props
		const paramId = new URLSearchParams(location.search).get('project')
		let message = 'Not allowed to checkin'
		console.log('checkArtist', this.props.roles, paramId)
		this.setState({
			isCheckingArtist: true
		})

		agent.Client.checkProjectArtist(projectId, artist.id).then(res => {
			console.log('checkProjectArtist',res);
			if (res.message || (res.meta && !res.meta.has_audition && !res.project.allow_new_artist_checkin) ) {
				
				this.setState({
					errorMessage: message,
					isCheckingArtist: false
				});
				this.onOpenModal();
			} else {
				this.setState({
					isCheckingArtist: false
				})
				this.props.history.push({
				  pathname: `/projects/checkin/${paramId}`,
				  state: { 
				  	artist: artist, 
				  	clientDetails: {
				  		client: res.companies[0],
				  		projectId: res.project
				  	},
				  	projectDetails: res,
				  	hasAudition: false
				  }
				})
			}

		}, error => {
			console.log('error', error)
			if (error.response.body.message == 'Artist already checked in') {
				message = error.response.body.message
			}

			this.setState({
				errorMessage: message,
				isCheckingArtist: false
			});
			this.onOpenModal();
		})

	}

  onSubmit = values => {
  	const { username, password } = values
  	const projectId = new URLSearchParams(this.props.location.search).get('project');
  	const publicRegistration = new URLSearchParams(this.props.location.search).get('token');
  	
  	if (username && password) {
  		if (projectId) {
  			return this.props.partialLogin(username, password)
  		} else if (publicRegistration) {
  			return this.props.publicLogin(username, password)
  		} else {
  			return this.props.artistLogin(username, password);		
  		}
  	}
  }
  
  onOpenModal = () => {
    this.setState({ showModal: true });
  }

  goBack = () => {
  	history.push('/projects')
  }
  
  onCloseModal = () => {
    this.setState({ showModal: false });
  }

	render() {
		const { location, errors, clientToken } = this.props
		const token = new URLSearchParams(location.search).get('token');
		const { projectId, loading } = this.state
		const imdb = new URLSearchParams(this.props.location.search).get('imdb')

		const style = {
			backgroundImage: `url(${Background})`,
			backgroundSize: 'cover'
		}
		const fix = {
			textTransform: 'none',
			paddingBottom: '2rem'
		}

    console.log('projectId-container', projectId)

    if (loading) {
      return (
        <div>
        <section id="brand-logo" className="section-brand-logo section">
          <div className="row">
          <div className="small-12 small-centered column text-center">
            <div className="header-image-container">
              <img className="am-logo" src={AMLogo} alt="" />
            </div>
            <p className="top-title">Audition Magic Check-in</p>
          </div>
          </div>
        </section>

        <section className="section gray-bg">
          <div className="grid-x align-center">
          <div className="small-12 medium-10 large-8 cell">

          <div className="text-center white-text">
            <h3>Loading details...</h3>
            <h5 className="loading-text">Please wait until all details have been loaded.</h5>
            <p></p>
          </div>

          </div>
          </div>
        </section>
        </div>)
    }
		
		return (
			<div>

				<Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal} onClose={this.onCloseModal} little>
          <h2 className="reveal-title">{this.state.errorMessage}</h2> 
          <p>Please speak to the person in charge of casting</p>
          <div className="clearfix"></div>
          <div className="row small-12 text-center">
	          <button className="button" onClick={this.onCloseModal}>Close</button>
          </div>
        </Modal>
        		{ imdb && (<ImDb />) }
				<Header {...this.props.location.state} token={token}/>
				
				<section id="artist-login" className="section-artist-login gray-bg section">
					<div className="row">
					<div className="small-12 small-centered column text-center">
						{
							token ? <Back /> : 
							<a onClick={this.goBack} className="back-button">
								<span className="fa-stack fa-lg">
								  <i className="fa fa-circle fa-stack-2x"></i>
								  <i className="fa fa-angle-left fa-stack-1x fa-inverse"></i>
								</span>
							</a>
						}
							
							<h2>TALENT LOGIN</h2>
						
							<div className="row">
								<div className="small-12 medium-6 large-4 small-centered column">
									<ArtistLoginForm 
										isCheckingArtist={this.state.isCheckingArtist}
										onSubmit={this.onSubmit} 
										initialValues={this.getInitialValues()}
										errors={errors} />

								</div>

								<div className="small-12 column small-centered">
								{ (projectId && clientToken)
									&& <FindMe 
											isCheckingArtist={this.state.isCheckingArtist} 
											checkArtist={this.checkArtist} 
											projectId={projectId}
											clientDetails={location.state} /> 
								}
								</div>

							</div>
						</div>
					</div>
				</section>

				<section id="artist-signin" className="section-artist-signin section">
					<div className="row">
					<div className="small-12 small-centered columns text-center">
					<p>
					{


					
					projectId && clientToken
					? location.state && location.state.projectId.allow_new_artist_checkin
						? <Link className="button hollow" 
									to={{pathname: "/artist/register", 
									search: `?project=${projectId.id}`, 
									state: { 
										projectId: location.state.projectId, 
										client: location.state.client 
									} }}>Create New Account</Link>
						: <button className="button hollow disabled">Create New Account</button>
					: token
						? <Link className="button hollow" 
									to={{pathname: "/artist/register", 
									search: `?token=${token}`}}>Create New Account</Link>
						: projectId
							? <Link className="button hollow" to={{
									pathname: '/artist/register', 
									search: `?project=${projectId}`,
									state: this.props.location.state }}>Create New Account</Link>
							: <Link className="button hollow" to="/artist/register">Create New Account</Link>
						
					}
					</p>
					</div>
					</div>
				</section>

			</div>
		)
	}
}


const mapStateToProps = state => ({
	...state.auth,
	...state.common,
	roles: state.common.roles
})

const mapDispatchToProps = dispatch => ({
	artistLogin: (username, password) => 
		dispatch({
			type: 'ARTIST_LOGIN', 
			payload: agent.Artist.login(username.toLowerCase(), password)
		}),
	partialLogin: (username, password) =>
		dispatch({ 
			type: 'PARTIAL_ARTIST_LOGIN', 
			payload: agent.Artist.login(username, password) }),
	publicLogin: (username, password) =>
		dispatch({ 
			type: 'PUBLIC_ARTIST_LOGIN', 
			payload: agent.Artist.login(username, password) }),
	onUnload: () => 
		dispatch({ type: 'ARTIST_PAGE_UNLOADED' }),
})

export default connect(mapStateToProps, mapDispatchToProps)(ArtistLoginContainer)



// WEBPACK FOOTER //
// ./src/containers/ArtistLoginContainer.js